import { DigitalRevisionMenuItem } from '../interfaces/digital-revision-menu-item';
import { ProxyTypeEnum } from '../interfaces/proxy-type-enum';
import { MenuItemTypeEnum } from '../interfaces/menu-item-type-enum';
import { MenuItemModel } from '../models/menu-item.model';

const sharedMenuBar: MenuItemModel[] = [
  {
    Text: 'Home',
    ImagePath: '/assets/images/landing/home.png',
    DestinationPage: '',
  },
  {
    Text: 'Quick Quiz',
    ImagePath: '/assets/images/landing/quick-quizzes.png',
    DestinationPage: 'Quick-Quiz',
  },
  {
    Text: 'Mistakes Quiz',
    ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
    DestinationPage: 'Mistakes-Quiz',
  },
  {
    Text: 'Summary Test',
    ImagePath: '/assets/images/landing/revision-summary-test.png',
    DestinationPage: 'Revision-Summary-Test',
  },
  {
    Text: 'Video Explanations',
    ImagePath: '/assets/images/landing/video-explanations.png',
    DestinationPage: 'Content-Videos',
  },
];

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.QuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a Quick Quiz',
    ButtonURL: 'quick-quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/CAS47/CAS47_QuickQuiz_v5',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Quick Quizzes',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      '<p>Test yourself with quizzes covering every topic. On your marks, get set... quiz!</p>\n' +
      '\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Last quiz score: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Questions on every topic',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#F0542C',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Mistakes Quiz',
    ButtonURL: 'mistakes-quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/CAS47/CAS47_YourMistakes_v3',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      '<p>The quick quiz questions you got wrong are here — have another go and conquer them once and for all!</p>\n' +
      '\n' +
      '<p>Total questions stored: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Total questions answered: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.RevisionSummary,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Revision Summary Tests',
    ButtonURL: 'revision-summary-test',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/CAS47/CAS47_RevSum_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Revision Summary Test',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      '<p>See how well you understand each section. Mark your answers with our examples.</p>\n' +
      '\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Questions marked <img src="assets/images/smiley-face-green.png" width="30" height="30" style="vertical-align:middle;" /> : <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'In-depth written questions',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.VideoExplanations,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#FF9335',
    ButtonCustomClasses: '',
    ButtonText: 'Watch explanations',
    MixedOnlineTests: [],

    ButtonURL: 'video-explanations',
    HasData: false,
    HeadingText: 'Video Explanations',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Our Science experts break down key concepts for you — even the tricky bits!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Get to grips with key concepts',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Video Explanations',
        Intro:
          'These handy videos explain some of the key concepts in your book. So grab your popcorn (or a pencil) and dig in!',
        LeftSections: [
          {
            Header: 'Topic 1a — Atoms, Elements, Compounds & Mixtures',
            Subcategories: [
              {
                Name: 'Structure of the Atom',
                ShortName: 'Structure-of-the-Atom',
                Link: 'https://www.youtube.com/embed/qlICQ6YZbWU?rel=0&modestbranding=1',
              },
              {
                Name: 'Paper Chromatography',
                ShortName: 'Paper-Chromatography',
                Link: 'https://www.youtube.com/embed/wrGI1vHoLtU?rel=0&modestbranding=1',
              },
              {
                Name: 'Separation Techniques',
                ShortName: 'Separation-Techniques',
                Link: 'https://www.youtube.com/embed/IeoWXK3we-E?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 1b — The Periodic Table',
            Subcategories: [
              {
                Name: 'The Gold Foil Experiment',
                ShortName: 'The-Gold-Foil-Experiment',
                Link: 'https://www.youtube.com/embed/SPP8PMbI5Ys?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 2b — States of Matter and Nanoparticles',
            Subcategories: [
              {
                Name: 'States of Matter',
                ShortName: 'States-of-Matter',
                Link: 'https://www.youtube.com/embed/ZsAhe9c5Dqs?rel=0&modestbranding=1',
              },
              {
                Name: 'Changes of State',
                ShortName: 'Changes-of-State',
                Link: 'https://www.youtube.com/embed/NQaIu23k91c?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 3 — Quantitative Chemistry',
            Subcategories: [
              {
                Name: 'Conservation of Mass',
                ShortName: 'Conservation-of-Mass',
                Link: 'https://www.youtube.com/embed/1-DNcOAA8ro?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 4 — Chemical Changes',
            Subcategories: [
              {
                Name: 'Electrolysis of Aqueous Solutions',
                ShortName: 'Electrolysis-of-Aqueous-Solutions',
                Link: 'https://www.youtube.com/embed/BJCm7ZkzTsM?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 5 — Energy Changes',
            Subcategories: [
              {
                Name: 'Fuel Cells',
                ShortName: 'Fuel-Cells',
                Link: 'https://www.youtube.com/embed/rI4Nqiea8LQ?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 6 — The Rate and Extent of Chemical Change',
            Subcategories: [
              {
                Name: 'Factors Affecting Rate of Reaction',
                ShortName: 'Factors-Affecting-Rate-of-Reaction',
                Link: 'https://www.youtube.com/embed/zd6J_TGK7og?rel=0&modestbranding=1',
              },
              {
                Name: "Le Chatelier\'s Principle",
                ShortName: "Le Chatelier\'s Principle",
                Link: 'https://www.youtube.com/embed/1Rqlv9XtVtQ?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 7 — Organic Chemistry',
            Subcategories: [
              {
                Name: 'Fractional Distillation',
                ShortName: 'Fractional-Distillation',
                Link: 'https://www.youtube.com/embed/Es1w80DhgWc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 8 — Chemical Analysis',
            Subcategories: [
              {
                Name: 'Tests for Gases',
                ShortName: 'Tests-for-Gases',
                Link: 'https://www.youtube.com/embed/ylwKHIoDp9c?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 9 — Chemistry of the Atmosphere',
            Subcategories: [
              {
                Name: 'Evolution of the Atmosphere',
                ShortName: 'Evolution-of-the-Atmosphere',
                Link: 'https://www.youtube.com/embed/MXQThYl7Eb8?rel=0&modestbranding=1',
              },
              {
                Name: 'Acid Rain',
                ShortName: 'Acid-Rain',
                Link: 'https://www.youtube.com/embed/OcMRovgs9WI?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 10 — Using Resources',
            Subcategories: [
              {
                Name: 'Sewage Treatment',
                ShortName: 'Sewage-Treatment',
                Link: 'https://www.youtube.com/embed/HZNkwK4pALw?rel=0&modestbranding=1',
              },
              {
                Name: 'The Haber Process',
                ShortName: 'The-Haber-Process',
                Link: 'https://www.youtube.com/embed/1m4xHr7Lsw4?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.VideoSolutions,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch solutions',
    MixedOnlineTests: [],

    ButtonURL: 'content-videos',
    HasData: false,
    HeadingText: 'Video Solutions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Learn how to answer the exam-style questions in your book</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Step-by-step exam answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Video Solutions',
        Intro:
          "CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book — have a go at the questions first and use these videos if you need a bit of extra help.",
        LeftSections: [
          {
            Header: 'Topic 1a — Atoms, Elements, Compounds & Mixtures',
            Subcategories: [
              {
                Name: 'Atoms',
                ShortName: 'Atoms',
                Link: 'https://www.youtube.com/embed/m1vMiZvzGaE?rel=0&modestbranding=1',
              },
              {
                Name: 'Calculating Relative Atomic Mass',
                ShortName: 'Calculating-Relative-Atomic-Mass',
                Link: 'https://www.youtube.com/embed/WakAOxVH4sY?rel=0&modestbranding=1',
              },
              {
                Name: 'Compound Formulas',
                ShortName: 'Compound-Formulas',
                Link: 'https://www.youtube.com/embed/ILzKxoQXf4Q?rel=0&modestbranding=1',
              },
              {
                Name: 'Chemical Equations',
                ShortName: 'Chemical-Equations',
                Link: 'https://www.youtube.com/embed/9ihnB-r4_qo?rel=0&modestbranding=1',
              },
              {
                Name: 'Distillation',
                ShortName: 'Distillation',
                Link: 'https://www.youtube.com/embed/340kfE8xEfs?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 1b — The Periodic Table',
            Subcategories: [
              {
                Name: 'Electronic Structure',
                ShortName: 'Electronic-Structure',
                Link: 'https://www.youtube.com/embed/M5zih_oL88E?rel=0&modestbranding=1',
              },
              {
                Name: 'Group 1 Elements',
                ShortName: 'Group-1-Elements',
                Link: 'https://www.youtube.com/embed/-8C9QmrxBx4?rel=0&modestbranding=1',
              },
              {
                Name: 'Group 7 Elements',
                ShortName: 'Group-7-Elements',
                Link: 'https://www.youtube.com/embed/DKl05_fJ8Rg?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 2a — Types of Bonding',
            Subcategories: [
              {
                Name: 'Ion Formation',
                ShortName: 'Ion-Formation',
                Link: 'https://www.youtube.com/embed/_tRLGRECAsY?rel=0&modestbranding=1',
              },
              {
                Name: 'Ionic Bonding',
                ShortName: 'Ionic-Bonding',
                Link: 'https://www.youtube.com/embed/TvZVyMC4soo?rel=0&modestbranding=1',
              },
              {
                Name: 'Ionic Compounds',
                ShortName: 'Ionic-Compounds',
                Link: 'https://www.youtube.com/embed/TpGQX5HCoKE?rel=0&modestbranding=1',
              },
              {
                Name: 'Covalent Bonding',
                ShortName: 'Covalent-Bonding',
                Link: 'https://www.youtube.com/embed/ZVMxvZML5qg?rel=0&modestbranding=1',
              },
              {
                Name: 'Polymers',
                ShortName: 'Polymers',
                Link: 'https://www.youtube.com/embed/3OLb-Y7U_7w?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 2b — States of Matter and Nanoparticles',
            Subcategories: [
              {
                Name: 'Changing State',
                ShortName: 'Changing-State',
                Link: 'https://www.youtube.com/embed/AtlF9E_4EkQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Nanoparticles',
                ShortName: 'Nanoparticles',
                Link: 'https://www.youtube.com/embed/meCxpTfo3eA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 3 — Quantitative Chemistry',
            Subcategories: [
              {
                Name: 'Calculating Percentage Composition',
                ShortName: 'Calculating-Percentage-Composition',
                Link: 'https://www.youtube.com/embed/AmUsRuohYpo?rel=0&modestbranding=1',
              },
              {
                Name: 'Mole Calculations',
                ShortName: 'Mole-Calculations',
                Link: 'https://www.youtube.com/embed/Zcg-CBzjh20?rel=0&modestbranding=1',
              },
              {
                Name: 'Conservation of Mass',
                ShortName: 'Conservation-of-Mass',
                Link: 'https://www.youtube.com/embed/1-DNcOAA8ro?rel=0&modestbranding=1',
              },
              {
                Name: 'Mole Equations',
                ShortName: 'Mole-Equations',
                Link: 'https://www.youtube.com/embed/bWNSyPkherM?rel=0&modestbranding=1',
              },
              {
                Name: 'Limiting Reactants',
                ShortName: 'Limiting-Reactants',
                Link: 'https://www.youtube.com/embed/SJk0mxKlzN8?rel=0&modestbranding=1',
              },
              {
                Name: 'Titration Calculations',
                ShortName: 'Titration-Calculations',
                Link: 'https://www.youtube.com/embed/kO_kNOVwSDE?rel=0&modestbranding=1',
              },
              {
                Name: 'Atom Economy',
                ShortName: 'Atom-Economy',
                Link: 'https://www.youtube.com/embed/0yqa0pmOqRk?rel=0&modestbranding=1',
              },
              {
                Name: 'Percentage Yield',
                ShortName: 'Percentage-Yield',
                Link: 'https://www.youtube.com/embed/V5GWeW12XgM?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 4 — Chemical Changes',
            Subcategories: [
              {
                Name: 'pH Calculations',
                ShortName: 'pH-Calculations',
                Link: 'https://www.youtube.com/embed/H-JZ08n9Hwo?rel=0&modestbranding=1',
              },
              {
                Name: 'Reactions of Acids',
                ShortName: 'Reactions-of-Acids',
                Link: 'https://www.youtube.com/embed/eGk6bylEi8M?rel=0&modestbranding=1',
              },
              {
                Name: 'Reactions of Metals',
                ShortName: 'Reactions-of-Metals',
                Link: 'https://www.youtube.com/embed/iJSIYFa-Alo?rel=0&modestbranding=1',
              },
              {
                Name: 'Separating Metals From Metal Oxides',
                ShortName: 'Separating-Metals-From-Metal-Oxides',
                Link: 'https://www.youtube.com/embed/t_ZjE0dyQqA?rel=0&modestbranding=1',
              },
              {
                Name: 'Redox Reactions',
                ShortName: 'Redox-Reactions',
                Link: 'https://www.youtube.com/embed/0grQz7zOOiE?rel=0&modestbranding=1',
              },
              {
                Name: 'Electrolysis of Molten Ionic Compounds',
                ShortName: 'Electrolysis-of-Molten-Ionic-Compounds',
                Link: 'https://www.youtube.com/embed/APpdE4PgEoU?rel=0&modestbranding=1',
              },
              {
                Name: 'Electrolysis of Aqueous Solutions',
                ShortName: 'Electrolysis-of-Aqueous-Solutions',
                Link: 'https://www.youtube.com/embed/LhOO3sSrxvs?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Topic 5 — Energy Changes',
            Subcategories: [
              {
                Name: 'Drawing Reaction Profiles',
                ShortName: 'Drawing-Reaction-Profiles',
                Link: 'https://www.youtube.com/embed/UW2AgzybgDE?rel=0&modestbranding=1',
              },
              {
                Name: 'Calculating Energy Changes',
                ShortName: 'Calculating-Energy-Changes',
                Link: 'https://www.youtube.com/embed/VoHCQpKddjI?rel=0&modestbranding=1',
              },
              {
                Name: 'Cells and Batteries',
                ShortName: 'Cells-and-Batteries',
                Link: 'https://www.youtube.com/embed/9O_wxm-rHZo?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 6 — The Rate and Extent of Chemical Change',
            Subcategories: [
              {
                Name: 'Measuring Rates of Reaction',
                ShortName: 'Measuring-Rates-of-Reaction',
                Link: 'https://www.youtube.com/embed/as_faH7blpQ?rel=0&modestbranding=1',
              },
              {
                Name: "Le Chatelier\'s Principle",
                ShortName: "Le Chatelier\'s Principle",
                Link: 'https://www.youtube.com/embed/1Rqlv9XtVtQ?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 7 — Organic Chemistry',
            Subcategories: [
              {
                Name: 'Combustion of Hydrocarbons',
                ShortName: 'Combustion-of-Hydrocarbons',
                Link: 'https://www.youtube.com/embed/yii1EOm5uyU?rel=0&modestbranding=1',
              },
              {
                Name: 'Separating Hydrocarbon Fractions',
                ShortName: 'Separating-Hydrocarbon-Fractions',
                Link: 'https://www.youtube.com/embed/5ifdkkq3SDM?rel=0&modestbranding=1',
              },
              {
                Name: 'Cracking Crude Oil',
                ShortName: 'Cracking-Crude-Oil',
                Link: 'https://www.youtube.com/embed/YiHC8GwPyls?rel=0&modestbranding=1',
              },
              {
                Name: 'Reactions of Alkenes',
                ShortName: 'Reactions-of-Alkenes',
                Link: 'https://www.youtube.com/embed/JT67cgELW5k?rel=0&modestbranding=1',
              },
              {
                Name: 'Addition Polymers',
                ShortName: 'Addition-Polymers',
                Link: 'https://www.youtube.com/embed/Z5IaE1oAaLY?rel=0&modestbranding=1',
              },
              {
                Name: 'Reactions of Carboxylic Acids',
                ShortName: 'Reactions-of-Carboxylic-Acids',
                Link: 'https://www.youtube.com/embed/jsh3QVYewG8?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 8 — Chemical Analysis',
            Subcategories: [
              {
                Name: 'Paper Chromatography',
                ShortName: 'Paper-Chromatography',
                Link: 'https://www.youtube.com/embed/wrGI1vHoLtU?rel=0&modestbranding=1',
              },
              {
                Name: 'Tests for Anions',
                ShortName: 'Tests-for-Anions',
                Link: 'https://www.youtube.com/embed/fvykbk4rEM4?rel=0&modestbranding=1',
              },
              {
                Name: 'Tests for Cations',
                ShortName: 'Tests-for-Cations',
                Link: 'https://www.youtube.com/embed/Bw2tkpbHgJU?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 9 — Chemistry of the Atmosphere',
            Subcategories: [
              {
                Name: 'The Greenhouse Effect',
                ShortName: 'The-Greenhouse-Effect',
                Link: 'https://www.youtube.com/embed/TiKgDB24lws?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 10 — Using Resources',
            Subcategories: [
              {
                Name: 'Calculating Alloy Composition',
                ShortName: 'Calculating-Alloy-Composition',
                Link: 'https://www.youtube.com/embed/GeR0TAEkigk?rel=0&modestbranding=1',
              },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.HowToRevise,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#0993A3',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: 'how-to-revise',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'How to Revise',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "We\'ve spilled all the secrets to help you get the most out of your book and CGP RevisionHub",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Revision tips and tricks',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        LeftSections: [],
        RightSections: [],
        Title: '',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      Intro: '',
      ProductTitle: '',
      TrackFilePaths: [],
      IntroTitle: '',
      AdditionalInfo: '',
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: 'GCSE Chemistry',
      BookType: 'Revision Guide',
      AdditionalText: "(you'll find some excellent jokes along the way)",
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#E04693',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Products',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    MixedOnlineTests: [],

    ButtonURL: 'extras',
    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>Printable answers, resource sheets, exam tips and a glossary... yep, it\'s all right here.</p>\n",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: 'Extra Useful Bits',
      ContentMain:
        '<p>Your printable answers, resource sheets, exam tips and more are all below. Take your pick!</p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/CAS47/PDFs/cgp-gcse-chemistry-commandwords-revisionandpractice.pdf" target="_blank">Command Word Glossary</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/CAS47/PDFs/cgp-gcse-chemistry-examrules-revisionandpractice.pdf" target="_blank">Golden Rules for Your Exams</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/CAS47/PDFs/cgp-gcse-chemistry-periodictable-revisionandpractice.pdf" target="_blank">The Periodic Table</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/CAS47/PDFs/cgp-gcse-chemistry-summaryanswers-higherrevisionandpractice.pdf" target="_blank">Revision Summary Test Answers</a></p>\n',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Watch our useful video to get started or take a look at the FAQs if you need some help.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our video and FAQs',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      TagLine:
        "We've put together lots of helpful information on how to get the most out of your Complete Revision & Practice. And if you've hit any snags, you'll find the answers you need here too.",
      Text:
        '    <h2>Frequently Asked Questions</h2>\n' +
        '\n' +
        '<h5>What is CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Science books. Use the quizzes, tests, videos and more to revise what you’ve learned from your book and practise for the exams.&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>How do I access CGP RevisionHub?</h5>\n' +
        '\n' +
        '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>How do I use CGP RevisionHub with my book?</h5>\n' +
        '\n' +
        "<p>You'll notice lots of QR codes scattered throughout your book. Just give them a scan and you'll automatically be taken to the relevant quiz, video or other revision thingy-ma-jig so you can practise exactly what you've just learned!<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>My RevisionHub isn’t working — what do I do?&nbsp;</h5>\n' +
        '\n' +
        '<p>If you can’t find the answer in these FAQs, it\'s time to contact our friendly <a href="#contact" style="color: #1494D4;">Customer Services team</a>.&nbsp;&nbsp;</p>\n' +
        '\n' +
        '<p>You could also ask your friendly neighbourhood psychic, but they will charge...<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Do I need an internet connection to use CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        "<p>Yes, you do. But don't cancel your revision retreat to a remote mountain cave just yet — there are also lots of useful bits that you can download as PDFs to access offline. Phew.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>If I log in on a different device, will all my progress be saved?&nbsp;</h5>\n' +
        '\n' +
        '<p>Yep. Just log in on your computer, tablet or phone, and all your progress and stats will be there waiting for you.<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What’s the difference between the Quick Quizzes, Your Mistakes Quiz and Revision Summary Tests?</h5>\n' +
        '\n' +
        "<p>Quick Quizzes are...well, quick! They're a speedy way to test yourself on all the key facts, maths skills and practical skills on the course. There's one on almost every page of your book — we're generous like that.</p>\n" +
        '\n' +
        "<p>Your Mistakes Quiz tests you on any questions you got wrong in your Quick Quizzes. It's really helpful for targeting those bits you find trickier.</p>\n" +
        '\n' +
        "<p>Revision Summary Tests include more challenging questions — if you can do them all, you'll know you've covered everything. You'll find one at the end of every section in your book and you can mark them yourself using our example answers.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Can I clear my progress so far in the Hub and start again?&nbsp;</h5>\n' +
        '\n' +
        "<p>There are no takie-backsies in CGP RevisionHub, so you can't clear your results and start again. But practice makes perfect, and you can take the quizzes as many times as you want to improve your scores. Plus, you can edit your Revision Summary Test answers as your skills and understanding develop. Keep going, we believe in you!<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Can I share my quiz scores and test results with other people?&nbsp;</h5>\n' +
        '\n' +
        "<p>You can't share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where's the fun in that?<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What happens when I’ve answered all the questions?&nbsp;</h5>\n' +
        '\n' +
        "<p>Ah, one of life's greatest questions — what next? We'd recommend that you keep practising right up until your exams. Check out the How To Revise page in your RevisionHub if you want more top revision tips before your exams.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Will I always have access to CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        "<p>Once you activate the code in the front of your book, you'll have access for three years. And they’ll be three whole years of bliss, we promise.<br>\n" +
        '&nbsp;</p>',
      VideoLink: 'https://www.youtube.com/embed/P8IHunVEtw0?rel=0&modestbranding=1',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "There's plenty more revision where this came from! Take a look at some of our other revision books.",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
];
